import type { i18n as I18n } from 'i18next'

// Power BI has no per-report, per-culture name, so the portal keeps its own reports.reportNames
// lookup (falls back to the raw name). Reads i18n.getResource directly, not t(), so fallbackLng
// can't leak an English translation onto a raw name that's already French.
export function localizeReportName(i18n: I18n, name: string) {
  const translated = i18n.getResource(i18n.language, 'translation', `reports.reportNames.${name}`)
  return typeof translated === 'string' ? translated : name
}
